import React, { useState, useEffect } from 'react';
import { motion as Motion, useMotionValue } from 'framer-motion';

const CustomCursor = () => {
  const [isHovered, setIsHovered] = useState(false); // For links/small interactive items
  const [isZoomed, setIsZoomed] = useState(false);   // For real buttons
  const [isVisible, setIsVisible] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  useEffect(() => {
    const checkDesktop = () => {
      setIsDesktop(window.innerWidth > 768 && !('ontouchstart' in window));
    };
    checkDesktop();
    window.addEventListener('resize', checkDesktop);
    
    const moveMouse = (e) => {
      mouseX.set(e.clientX);
      mouseY.set(e.clientY);
      if (!isVisible) setIsVisible(true);
    };

    const handleMouseOver = (e) => {
      const target = e.target;
      if (!target || !target.tagName) return;

      const isButton = target.tagName === 'BUTTON' || target.closest?.('button');
      const isLink = target.tagName === 'A' || target.closest?.('a');
      const isCustomInteractive = target.closest?.('.cursor-zoom');
      const isCustomHover = target.closest?.('.cursor-hover');
      
      if (isButton || isCustomInteractive) {
        setIsZoomed(true);
        setIsHovered(false);
      } else if (isLink || isCustomHover) {
        setIsHovered(true);
        setIsZoomed(false);
      } else {
        setIsHovered(false);
        setIsZoomed(false);
      }
    };

    const handleMouseOut = () => {
      setIsHovered(false);
    };

    window.addEventListener('mousemove', moveMouse);
    window.addEventListener('mouseover', handleMouseOver);
    window.addEventListener('mouseout', handleMouseOut);

    return () => {
      window.removeEventListener('resize', checkDesktop);
      window.removeEventListener('mousemove', moveMouse);
      window.removeEventListener('mouseover', handleMouseOver);
      window.removeEventListener('mouseout', handleMouseOut);
    };
  }, [mouseX, mouseY, isVisible]);

  if (!isDesktop || !isVisible) return null;

  return (
    <>
      <style>{`
        @media (min-width: 769px) {
          * {
            cursor: none !important;
          }
        }
      `}</style>
      
      {/* Inner Dot */}
      {/* Removed center dot as requested */}

      {/* Outer Circle — solid fill at all times (mix-blend-difference
          inverts against whatever's underneath, so a filled dot stays
          readable on both light and dark backgrounds), scaling up on
          hover/zoom the same as before. */}
      <Motion.div
        className="fixed top-0 left-0 w-4 h-4 rounded-full z-[99998] pointer-events-none mix-blend-difference bg-white"
        style={{
          x: mouseX,
          y: mouseY,
          translateX: '-50%',
          translateY: '-50%',
        }}
        animate={{
          scale: isZoomed ? 2.5 : isHovered ? 1.8 : 1,
        }}
        transition={{ duration: 0.2 }}
      />
    </>
  );
};

export default CustomCursor;
